export enum TaskStatus {
    NotStarted = 1,
    InProgress,
    Completed,
    WaitingOnSomeoneElse,
    Deferred,
    Other
}

export enum TaskPriority {
    High = 1,
    Normal,
    Low,
}



// WEBPACK FOOTER //
// ./client/app/shared/tasks/task-types.enum.ts